import {
  Button,
  Card,
  CardMedia,
  Divider,
  Grid,
  makeStyles,
  Typography,
} from "@material-ui/core";
import "./HeroCard.css";
import React, { Component } from "react";
import adyaBannerlogo from "../../../../images/indian-bank/Group 14894 (1).svg";

// const useStyles = makeStyles({
//   root: {
//     maxWidth: 345,
//   },
//   media: {
//     height: 140,
//   },
// });

export default class HeroCardMenu extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    // const { classes } = this.props;
    return (
      // <Grid container alignItems="center">
      <div id="background" className="msg-content-wrapper message-content-wrapper-bot msg-content-wrapper-border width-70"style={{ border: "8px solid rgba(244, 176, 53, 0.8)" ,backgroundColor:"rgba(245, 243, 243, 1) !important"
      }}>
        <Grid item xs>
          <Typography
            variant="button"
            display="block"
            align="center"
            gutterBottom
          >
            {/* {this.props.herocardData.title} */}
            <h4 style={{ color: "rgba(12, 77, 162, 1)",textAlign:"center",fontWeight:"600",fontSize:"14px"}}
                className="hero_card_title">{this.props.herocardData.title}</h4>
          </Typography>
          <Grid item xs>
            <Card>
              <CardMedia component="img" image={adyaBannerlogo} alt="ib"  style={{backgroundColor:"rgba(245, 243, 243, 1)"}}/>
            </Card>
          </Grid>
        </Grid>
        <Divider variant="middle" />
        <div className="herocard_div">
          <Grid item>
            <Typography
              variant="caption"
              display="block"
              align="center"
              gutterBottom
            >
              {/* {this.props.herocardData.subtitle} */}
              <h6 className="hero_card_subtitle">
                {this.props.herocardData.subtitle}
              </h6>
            </Typography>
          </Grid>
          <Typography
            variant="caption"
            display="block"
            gutterBottom
            className="typography_link_center"
          >
            <Button
              variant="outlined"
              size="small"
              href={this.props.herocardData.url}
              target="_blank"
            >
              Click here for details
            </Button>
          </Typography>
        </div>
      </div>
      // </Grid>
    );
  }
}
